import React from "react";
import { Skeleton } from "components/ui/skeleton";

/**
 * WidgetCardSkeleton
 * Shimmer placeholder for Widget cards (Newsletter / Promotion Banner)
 */
export function WidgetCardSkeleton() {
    return (
        <div className="p-5 bg-surface border rounded-2xl shadow-sm hover:shadow-md transition-all hover-lift fade-in space-y-4">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                    {/* small icon */}
                    <Skeleton variant="avatar" className="!w-8 !h-8 rounded-md" />
                    <div className="space-y-1">
                        <Skeleton variant="text" className="!w-40 !h-4" />
                        <Skeleton variant="text" className="!w-28 !h-3" />
                    </div>
                </div>
                {/* Action buttons */}
                <div className="flex items-center gap-2">
                    <Skeleton className="h-8 w-8 rounded-lg" />
                    <Skeleton className="h-8 w-8 rounded-lg" />
                </div>
            </div>

            {/* Preview Frame */}
            <div className="border border-line dark:border-gray-700 rounded-xl overflow-hidden relative">
                <Skeleton className="w-full h-[220px]" />
                {/* floating copy icon placeholder */}
                <div className="absolute top-2 right-2">
                    <Skeleton className="h-8 w-8 rounded-md" />
                </div>
            </div>

            {/* Footer Actions */}
            <div className="flex items-center justify-end gap-2 pt-3">
                <Skeleton className="h-9 w-20 rounded-full" />
                <Skeleton className="h-9 w-20 rounded-full" />
                <Skeleton className="h-9 w-20 rounded-full" />
            </div>
        </div>
    );
}

/**
 * WidgetGridSkeleton
 * Grid wrapper for loading multiple widget cards
 */
export function WidgetGridSkeleton({ count = 4 }: { count?: number }) {
    return (
        <div
            id="widget-grid-skeleton"
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
            role="grid"
            aria-label="Loading widgets"
        >
            {Array.from({ length: count }).map((_, i) => (
                <WidgetCardSkeleton key={i} />
            ))}
        </div>
    );
}
